export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11850.d03b6342.jpg";